<template>
  <div class="information">
    <ul>
      <li>参与活动名称：{{ information.activityName }}</li>
      <!-- <li>活动序号：{{ information.num }}</li> -->
      <li>获奖人姓名：{{ information.userName }}</li>
      <li>获奖人手机号：{{ information.userPhone }}</li>
      <li>获得奖品：{{ information.prizeName }}</li>
      <li>获奖时间：{{ information.createTime }}</li>
      <li>
        核销状态：{{ information.sendStatus == '1001' ? '待核销' : '已核销' }}
      </li>
    </ul>
    <button
      class="btn"
      :class="information.sendStatus == '1002' ? 'disabled' : ''"
      :disabled="information.sendStatus == '1002'"
      @click="writeOff()"
    >
      核销
    </button>
  </div>
</template>
<script>
import { appManualOff } from '@/api/activity'
export default {
  name: 'information',
  data() {
    return {
      information: {},
      userCode: '',
    }
  },
  mounted() {
    document.title = '核销'
    this.information = JSON.parse(localStorage.getItem('information'))
  },
  methods: {
    writeOff() {
      this.$confirm('确定要核销？', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        appManualOff(this.information.id).then((res) => {
          if (res.code == '1000') {
            this.information.sendStatus = '1002'
            localStorage.setItem(
              'information',
              JSON.stringify(this.information)
            )
            this.$message({message: '核销成功',type: 'success'})
          }
        })
      }).catch(() => {
        this.$message({message: '已取消',type: 'info'})        
      });
    },
  },
}
</script>
<style lang="less" scoped>
@supports (
    (height: constant(safe-area-inset-top)) or
      (height: env(safe-area-inset-top))
  )
  and (-webkit-overflow-scrolling: touch) {
  body {
    /* 适配齐刘海 */
    padding-top: 20px;
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);

    /* 适配底部小黑条 */
    padding-bottom: 0;
    padding-bottom: costant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
.information {
  height: 100vh;
  overflow: hidden;
  padding: 4vh 4vw;
  background: #f6f8f9;
  ul {
    width: 100%;
    height: 50vh;
    background: #ffffff;
    border-radius: 3.38vw;
    padding: 2.55vh 2.9vw;
    li {
      line-height: 7vh;
      font-size: 4vw;
    }
  }
  .btn {
    display: block;
    background: url('~@/assets/img/btn_bg.png') no-repeat;
    background-size: 100% 100%;
    width: 50.7vw;
    height: 8.325vh;
    border: none;
    margin: 4vh auto;
    color: #fffbf5;
    text-shadow: 0px 2px 0px rgba(10, 31, 62, 0.15);
    font-size: 5.72vw;
    border-radius: 18.5vw;
  }
  .disabled {
    background: linear-gradient(267deg, #ccc, #ccc);
    border: 2px solid #efefef;
    -webkit-box-shadow: 0px 3px 0px 0px rgba(109, 90, 17, 0.19);
    box-shadow: 0px 3px 0px 0px rgba(109, 90, 17, 0.19);
    color: #666;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/components/writeOffInformation.vue